// extracted by mini-css-extract-plugin
export default {"mainSlider":"MainSlider_mainSlider__wJCBL","title":"MainSlider_title__G+AUX"};